const DASHES_REGEX = /[-\s]/g;

export const parseAndConvertKitId = {
  methods: {
    /**
     * Parses the kit format 00-F1-000-0000 to 00F10000000.
     * @param {string} kitId kit id with or without dashes.
     */
    parseKitId(kitId) {
      return kitId
        ? kitId
            .replace(DASHES_REGEX, "")
            .substr(0, 11)
            .toUpperCase()
        : undefined;
    },

    /**
     * Converts the kit id from 00F10000000 to 00-F1-000-0000.
     * @param {string} kitId kit id with or without dashes.
     */
    convertKitId(kitId) {
      const rawKitId = this.parseKitId(kitId);
      return rawKitId
        ? `${rawKitId.substr(0, 2)}-${rawKitId.substr(2, 2)}-${rawKitId.substr(
            4,
            3
          )}-${rawKitId.substr(7, 4)}`
        : undefined;
    }
  }
};
